import React from "react";
import "./Award.scss";
import awardImg from "../../../assets/Reports/award.png";

const Award = () => {
  return (
    <>
      <div className="award">
        <div className="container">
          <div className="heading_box">Award & Achievement</div>
          <div className="text-center">
            <img src={awardImg} className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Award;
